import { useTranslations } from 'next-intl';

import Heading from '../Heading';
import P from '../P';
import Section from '../Section';
import getValues from '../utils/getValues';

const values = getValues();

const IpPatents = (): JSX.Element => {
  const t = useTranslations();
  return (
    <>
      <Heading tx="ip_patents_heading" />

      <Section title="ip_patents_ring_title">
        <ul>{t.rich('ip_patents_ring_list', values)}</ul>
      </Section>

      <Section title="ip_patents_app_title">
        <ul>{t.rich('ip_patents_app_list', values)}</ul>
      </Section>

      <P tx="ip_registered_trademarks_intro" className="my-12" />

      <Section title="ip_registered_trademarks_title">
        <ul>{t.rich('ip_registered_trademarks_list', values)}</ul>
      </Section>
    </>
  );
};

export default IpPatents;
